<div
  aria-atomic="true"
  aria-live="polite"
  class="mat-mdc-form-field-subscript-wrapper mat-mdc-form-field-bottom-align mat-mdc-form-field-subscript-dynamic-size -ml-2"
>
  <div class="mat-mdc-form-field-error-wrapper">
    <mat-error>
      {{ error() }}
    </mat-error>
  </div>
</div>
